export default
{
    "items": [
        {
            "title": "Hand Watch",
            "description": "ui/ux design",
            "img": "Watch.jpg"
        },
        {
            "title": "One Day Pass",
            "description": "ui/ux design",
            "img": "Pass.jpg"
        },
        {
            "title": "T-shirt",
            "description": "ui/ux design",
            "img": "T-shirt.jpg"
        },
        {
            "title": "Bottle",
            "description": "ui/ux design",
            "img": "Bottle.jpg"
        },
        {
            "title": "Bottle Of Wine",
            "description": "ui/ux design",
            "img": "Wine.jpg"
        },
        {
            "title": "Big Bag",
            "description": "ui/ux design",
            "img": "Bag.jpg"
        }
    ]
}